import { render } from "./ProcesoExitoso.vue?vue&type=template&id=3a3bc2ff&scoped=true"
import script from "./ProcesoExitoso.vue?vue&type=script&lang=js"
export * from "./ProcesoExitoso.vue?vue&type=script&lang=js"

import "./ProcesoExitoso.vue?vue&type=style&index=0&id=3a3bc2ff&scoped=true&lang=css"

import exportComponent from "/home/runner/work/FONSNTE/FONSNTE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a3bc2ff"]])

export default __exports__